

class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
  
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.searchAllButton = document.getElementById('predictive-search-all');

    this.setHeight();

    window.addEventListener("resize", () => {
      this.setHeight();
    });

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  setHeight() {
    let headHeight = 0;
    let annBarHeight = 0;

    if (this.parentElement.classList.contains('buly--search-desktop')) {
      // this.querySelector('#predictive-search').style.maxHeight = "calc(100vh - " + this.querySelector('form.search--desktop').getBoundingClientRect().bottom + "px)";
    } else {
      const annBar = document.querySelector('#shopify-section-announcement-bar');
      const header = document.querySelector('#shopify-section-header.buly-header');
      if (annBar) {
        headHeight = annBar.offsetHeight;
        annBarHeight = annBar.offsetHeight;
      }
      if (header) {
        headHeight += header.offsetHeight - annBarHeight;
      }
      if (this.dataset.emplacement === 'header-mobile') {
        this.querySelector('#predictive-search').style.width = "100%";
        this.querySelector('#predictive-search').style.overflow = "unset";
      }else{
        this.querySelector('#predictive-search').style.position = "absolute";
        this.querySelector('#predictive-search').style.top = headHeight + "px"; 
        this.querySelector('#predictive-search').style.maxHeight = "calc(100vh - " + headHeight + "px)";
        this.querySelector('#predictive-search').style.marginLeft = "-2rem";
        this.querySelector('#predictive-search').style.width = "100vw";
      }
      this.querySelector('#predictive-search').style.paddingTop = "20px";
      this.querySelector('#predictive-search').style.background = "#ffffff";
      this.querySelector('#predictive-search').style.borderTop = "1px solid #DDDDDD";
    }
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    var root_url = Shopify.routes.root;
    fetch(`${root_url}search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=20&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.dataset.active = true;
    this.predictiveSearchResults.style.display = 'block';
    this.searchAllButton.style.display = 'block';
    if (this.classList.contains('desktop-predictive')) {
      this.classList.remove('tw-overflow-auto');
      this.scrollTo(0, 0);
    }
  }

  close() {
    this.dataset.active = false;
    this.predictiveSearchResults.style.display = 'none';
    this.searchAllButton.style.display = 'none';
    if (this.classList.contains('desktop-predictive')) {
      this.classList.add('tw-overflow-auto');
    }
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);
